module.exports = __webpack_public_path__ + "img/success-check.48b040a6.svg";